﻿window.jobQueueFunc = function () {
    let allCheckBoxId, checkboxesId, selectedValuesId, changeTimeButtonId, tableId;

    var instance = {
        get allCheck() {
            return document.querySelector(allCheckBoxId);
        },
        get changeTimeButton() {
            return document.querySelector(changeTimeButtonId);
        },
        get selectedValues() {
            return document.querySelector(selectedValuesId);
        },
        get checkboxes() {
            return Array.from(document.querySelectorAll(checkboxesId))
        },
        get table() {
            return document.querySelector(tableId);
        },

        init([allCheckBox, timedCheckBox, selectedValues, changeTimeButton, table]) {
            allCheckBoxId = '#' + allCheckBox
            checkboxesId = '#' + timedCheckBox;
            selectedValuesId = '#' + selectedValues;
            changeTimeButtonId = '#' + changeTimeButton;
            tableId = '#' + table;
        },
        
        toggleAll: function () {
            let allCheckValue = this.allCheck.checked;
            this.checkboxes.forEach(c => {
                c.checked = allCheckValue;
            })
            this.updateSelected();
        },
        
        checkboxClick: function () {
            this.allCheck.checked = this.checkboxes.every(c => c.checked)
            this.updateSelected();
        },        
        
        updateSelected() {
            this.selectedValues.value = this.checkboxes.filter(c => c.checked).map(c => $(c).closest('tr').data().rowid).join(',')
            $(this.changeTimeButton).toggleClass('disabled', this.selectedValues.value == '');
        },       
        
        showDialog(id) {
            let dialogMarkup = document.getElementById(id);
            dialog.open(dialogMarkup);
        },
        refresh() {
            let rowWithSplitter = this.table.querySelector('.jobQueue-rowsplitter');
            if(rowWithSplitter) {
                let header = this.table.querySelector('tr:first-child');
                let wrapper = this.table.parentElement;
                wrapper.scrollTop = rowWithSplitter.offsetTop - wrapper.offsetHeight/2 - header.offsetHeight + rowWithSplitter.offsetHeight/2
                // work incorrect with fixed header;
                // rowWithSplitter?.scrollIntoView({block: "center"});
            }
            this.updateSelected();
        }
    }
    return instance;
}();




